const styles = () => ({
  form: {
    padding: 20
  }
});

export default styles;
